import _ from 'lodash';

export const convertToUpperSnakeCase = (key: string) =>
  _.snakeCase(key).toUpperCase();

export const convertToCamesCase = (key: string) => _.camelCase(key);

export const parseAge = (arr: [string, string][], key: string) =>
  arr
    .find(i => i.includes(key))
    ?.filter(i => i !== key)?.[0]
    ?.split('-')
    ?.map(i => Number(i)) as [number, number];

export const hasFiltersByKey = (
  arr: [string, string][] | undefined,
  key: string | string[],
) => {
  if (arr) {
    return !!arr.find(i =>
      Array.isArray(key) ? key.some(key => i.includes(key)) : i.includes(key),
    );
  }
};
